const protfolioData = [
    {
        id: "1",
        mainCategories: "Aqaba",
        data: [
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(1).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(2).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(3).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(4).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(5).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(6).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(7).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(8).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(9).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(10).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(11).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(12).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(13).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(14).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(15).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(16).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(17).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(18).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(19).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(20).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(21).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(22).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(23).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(24).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(25).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(26).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(27).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(28).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(29).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(30).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(31).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(32).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(33).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(34).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(35).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(36).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(37).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(38).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(39).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(40).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(41).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(42).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(43).JPG",
            "https://aqaba-seasons.com/images-we/Aqaba/aqaba-1%20(44).JPG",
        ]
    },
    {
        id: "2",
        mainCategories: "Petra",
        data: [
            "https://aqaba-seasons.com/petra/petra-1%20(1).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(2).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(3).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(4).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(5).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(6).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(7).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(8).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(9).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(10).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(11).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(12).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(13).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(14).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(15).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(16).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(17).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(18).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(19).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(20).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(21).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(22).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(23).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(24).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(25).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(26).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(27).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(28).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(29).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(30).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(31).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(32).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(33).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(34).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(35).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(36).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(37).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(38).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(39).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(40).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(41).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(42).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(43).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(44).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(45).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(46).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(47).JPG",
            "https://aqaba-seasons.com/petra/petra-1%20(48).JPG",
        ]
    },
    {
        id: "3",
        mainCategories: "Wadi Rum",
        data: [
            "https://aqaba-seasons.com/rum/rum-1%20(1).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(2).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(3).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(4).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(5).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(6).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(7).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(8).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(9).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(10).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(11).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(12).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(13).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(14).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(15).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(16).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(17).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(18).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(19).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(20).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(21).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(22).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(23).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(24).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(25).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(26).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(27).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(28).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(29).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(30).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(31).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(32).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(33).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(34).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(35).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(36).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(37).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(38).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(39).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(40).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(41).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(42).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(43).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(44).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(45).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(46).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(47).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(48).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(49).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(50).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(51).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(52).JPG",
            "https://aqaba-seasons.com/rum/rum-1%20(53).JPG",
        ]
    },
]

export default protfolioData;